module.exports = __webpack_public_path__ + "static/media/LocalLodging.78cd123d.svg";